module.exports = __webpack_public_path__ + "static/screen-shot-2020-09-03-at-1.02.41-pm-f2818158c2a64e88995bf0f075963041.png";